import {API_ORGANIZATION_TREE, API_ORGANIZATION_LIST, API_ORGANIZATION_DELETE, API_ORGANIZATION_SAVE, API_EMPLOYEE_ONTIN_DEPARTMENT_LIST} from '@/common/constants';
import { get, post, del } from '@/utils/http';

const pendingEmployeeListRequestMap = new Map();

const sortRequestParams = (value) => {
    if (Array.isArray(value)) {
        return value.map(item => sortRequestParams(item));
    }
    if (value && typeof value === 'object') {
        return Object.keys(value).sort().reduce((result, key) => {
            if (value[key] !== undefined) {
                result[key] = sortRequestParams(value[key]);
            }
            return result;
        }, {});
    }
    return value;
};

const buildEmployeeListRequestKey = (params) => {
    return 'getEmployeeListByDepartmentId::' + JSON.stringify(sortRequestParams(params));
};

export const getOrganizationTree = () => {
    return get(API_ORGANIZATION_TREE, {});
};

export const getEmployeeListByDepartmentId = (currentPage = 1, pageSize = 10, departmentId, keyWord, positionIds) => {
    let params = {currentPage, pageSize, departmentId: departmentId, trueName: keyWord, positionIds: positionIds};
    let requestKey = buildEmployeeListRequestKey(params);
    if (pendingEmployeeListRequestMap.has(requestKey)) {
        return pendingEmployeeListRequestMap.get(requestKey);
    }
    let requestPromise = get(API_ORGANIZATION_LIST, params).finally(() => {
        pendingEmployeeListRequestMap.delete(requestKey);
    });
    pendingEmployeeListRequestMap.set(requestKey, requestPromise);
    return requestPromise;
};

export const delEmployeeDepartment = (id) => {
    return del(API_ORGANIZATION_DELETE.replace(':id', id));
};

export const saveMultEmployeeDepartment = (employeeDepartment) => {
    return post(API_ORGANIZATION_SAVE, employeeDepartment);
};

export const getEmployeeListNotInDept = (currentPage = 1, pageSize = 10, departmentId, keyWord) => {
    return get(API_EMPLOYEE_ONTIN_DEPARTMENT_LIST, {currentPage, pageSize, departmentId: departmentId, trueName: keyWord});
};



// WEBPACK FOOTER //
// ./src/data-model/system/organization-model.js